/**
 * Custom logging utility that provides styled console output when debugging is enabled.
 * Supports regular logging, collapsible groups, and table formatting with color-coded status styles.
 * Only outputs logs when DEBUG flag is true.
 */
(function (g) {
  const DEBUG = true || window.Shopify?.theme?.role === 'development' || window.Shopify?.theme?.role === 'unpublished',
    styles = {
      success: "background:darkgreen;color:white;padding:2px 6px;border-radius:3px",
      error: "background:darkred;color:white;padding:2px 6px;border-radius:3px",
      warning: "background:darkorange;color:white;padding:2px 6px;border-radius:3px",
      info: "background:blue;color:white;padding:2px 6px;border-radius:3px",
      filename: "background:#333;color:#bada55;padding:2px 6px;border-radius:3px;margin-left:4px"
    };

  const getCallerFile = () => {
    try {
      return (new Error().stack.split('\n').find(l => (l.includes('/assets/') || l.includes('/sections/') || l.includes('/snippets/')) && !l.includes('/custom_sitewide.js') || !l.includes('jquery-')) || '')
        .match(/\/(assets|sections|snippets)\/([^:?]+)\??/)?.[2] || '';
    } catch (e) { return ''; }
  };

  const log = (...args) => DEBUG && console.log(...args);

  const collapse = (type, data, title = "Log", status = "info") => {
    if (!DEBUG) return;
    const file = getCallerFile();
    console.groupCollapsed(`%c ${title}${file ? ' %c' + file : ''}`,
      styles[status] || styles.info, file ? styles.filename : '');
    type === "table" ? console.table(data) : console.log(data);
    console.groupEnd();
  };

  log.table = (data, title, status) => collapse("table", data, title, status);
  log.collapse = (data, title, status) => collapse("log", data, title, status);
  g.log = log;
})(typeof window !== "undefined" ? window : globalThis);

const log = window.log;

/**
 * Initializes and manages a Slick carousel with separate mobile and desktop configurations.
 * Ensures no unnecessary reinitialization during window resizing.
 *
 * @param {jQuery} carousel - The carousel element(s).
 * @param {Object} mobileOptions - Slick options for mobile view.
 * @param {number} breakpoint - The breakpoint to switch between mobile and desktop configurations.
 * @param {Object|null} desktopOptions - Slick options for desktop view. If null, unslick on desktop.
 */
function handleResponsiveCarousel(carousel, mobileOptions, breakpoint = 1024, desktopOptions = null) {
  let currentView = null; // Keeps track of the current view ('mobile' or 'desktop')

  function initializeCarousel() {
    const isDesktop = $(window).width() >= breakpoint;

    if (isDesktop) {
      if (currentView !== 'desktop') {
        // Switch to desktop view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy mobile Slick if initialized
        if (desktopOptions) carousel.slick(desktopOptions); // Initialize with desktop options
        currentView = 'desktop';
      }
    } else {
      if (currentView !== 'mobile') {
        // Switch to mobile view
        if (carousel.hasClass('slick-slider')) carousel.slick('unslick'); // Destroy desktop Slick if initialized
        carousel.slick(mobileOptions); // Initialize with mobile options
        currentView = 'mobile';
      }
    }
  }

  initializeCarousel();
  $(window).on('resize', function () {
    initializeCarousel();
  });
}

// Function to copy text to clipboard
function copyToClipboard(text) {
  var $tempInput = $("<input>");
  $("body").append($tempInput);
  $tempInput.val(text).select();
  document.execCommand("copy");
  $tempInput.remove();
}


$(document).ready(function () {
  const icons = {
    arrow_left: 'https://cdn.shopify.com/s/files/1/0742/1896/3239/files/Arrow_Left.svg?v=1749648531',
    arrow_right: 'https://cdn.shopify.com/s/files/1/0742/1896/3239/files/Arrow_Right.svg?v=1749648531',
    chevron_left: 'https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Left.png?v=1737122129',
    chevron_right: 'https://cdn.shopify.com/s/files/1/0679/7135/0705/files/Chevron_Right.png?v=1737122129'
  };
  function slickButton(iconUrl, direction) {
    const label = direction === 'left' ? 'Arrow Left' : 'Arrow Right';
    const arrowClass = direction === 'left' ? 'left_arrow' : 'right_arrow';
    const buttonClass = direction === 'left' ? 'slick-prev pull-left' : 'slick-next pull-right';
    return `<button type='button' aria-label='${label}' class='${buttonClass}'><img class='${arrowClass}' src='${iconUrl}' alt='arrow'/></button>`;
  }


  if ($('.rl-products__products').length > 0) {
    $('.rl-products__products.carousel').slick({
      autoplay: true,
      autoplaySpeed: 5000,
      infinite: true,
      slidesToShow: 4,
      slidesToScroll: 4,
      arrows: false,
      dots: false,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3
          }
        }, {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2
          }
        }, {
          breakpoint: 540,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    });
  }
  $('.landing-hero__image-carousel').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    prevArrow: slickButton(icons.arrow_left, 'left'),
    nextArrow: slickButton(icons.arrow_right, 'right')
  });

  if ($('.landing-hero__image-carousel--thumbnails').length > 0) {
    $('.landing-hero__image-carousel--thumbnails').each(function () {
      const container = $(this);
      let isDown = false;
      let startX;
      let scrollLeft;

      // Prevent image dragging
      container.find('img, video').attr('draggable', false);

      // Mouse events for scrolling
      container
        .on('mousedown', function (e) {
          isDown = true;
          container.addClass('grabbing');
          startX = e.pageX;
          scrollLeft = container.scrollLeft();
          e.preventDefault();
        })
        .on('touchstart', function (e) {
          isDown = true;
          container.addClass('grabbing');
          startX = e.originalEvent.touches[0].pageX;
          scrollLeft = container.scrollLeft();
        })
        .on('mouseleave mouseup', function () {
          isDown = false;
          container.removeClass('grabbing');
        })
        .on('touchend touchcancel', function () {
          isDown = false;
          container.removeClass('grabbing');
        })
        .on('mousemove', function (e) {
          if (!isDown) return;
          e.preventDefault();
          const x = e.pageX;
          const walk = (startX - x) * 1.5;
          container.scrollLeft(scrollLeft + walk);
        })
        .on('touchmove', function (e) {
          if (!isDown) return;
          const x = e.originalEvent.touches[0].pageX;
          const walk = (startX - x) * 1.5;
          container.scrollLeft(scrollLeft + walk);
          e.preventDefault(); // Prevent page scrolling while dragging thumbnails
        });

      // Click on thumbnails to navigate
      container.on('click', '.landing-hero__image-carousel-item', function () {
        if (isDown) return; // Don't trigger click when dragging
        const index = $(this).data('index');
        $('.landing-hero__image-carousel').slick('slickGoTo', index);
      });
    });
  } else {
    log('Thumbnails Do Not Exist');
  }

  const Example = $('.example-section');
  const ExampleOptions = {
    infinite: true,
    dots: true,
    arrows: false,
    slidesToShow: 1,
    slidesToScroll: 1
  };
  const ExampleOptionsDesktop = {
    infinite: true,
    dots: false,
    arrows: false,
    slidesToShow: 2,
    slidesToScroll: 2
  };
  handleResponsiveCarousel(Example, ExampleOptions, 1024, ExampleOptionsDesktop);


  // Append rl-products shop-all button on mobile
  function moveShopAll() {
    $(window).width() < 768
      ? $('.rl-products .heading-shop-all').appendTo('.rl-products__container')
      : $('.rl-products .heading-shop-all').appendTo('.rl-products .heading-wrapper');
  }
  moveShopAll();
  $(window).resize(moveShopAll);

  // Append FAQ cta button over faq image
  $('.faq-split__cta-wrapper.append .cta-kandy').appendTo('.faq-split__image');
  // Append Image Content button over Image
  $('.image-content__cta-wrapper.append .cta-kandy').each(function () {
    $(this).appendTo($(this).closest('.image-content').find('.image-content__image'));
  });
  // Append Image Content Card button over Image
  $('.content-card__cta-wrapper.append .cta-kandy, .content-card .logo-image.append').each(function () {
    $(this).appendTo($(this).closest('.content-card').find('.content-card__image'));
  });

  if ($('.exp-reviews__load-more-btn').length > 0) {
    $('.exp-reviews__load-more-btn').on('click', function () {
      const $container = $(this).closest('.exp-reviews');
      const reviewsBatch = $container.find('.exp-reviews__reviews').data('reviews-batch');
      const hiddenReviews = $container.find('.exp-reviews__review.hidden');
      // Show next batch of reviews
      hiddenReviews.slice(0, reviewsBatch).removeClass('hidden');
      // If no more hidden reviews, hide the button
      if (hiddenReviews.length <= reviewsBatch) {
        $(this).addClass('hidden');
      }
    });
  }



  // Announcement Timer
  function AnnouncementTimer() {
    const timerWrap = $('.announcement__timer');
    if (!timerWrap.length) return;

    const timer = timerWrap.find('.timer');
    let time;

    const timerDate = timerWrap.data('timer-date');
    if (timerDate) {
      const targetTime = new Date(timerDate + "T00:00:00"); // Local midnight of the given date
      time = Math.floor((targetTime - new Date()) / 1000); // Time difference in seconds
    } else {
      time = parseInt(timerWrap.data('time'), 10);
    }
    if (time <= 0) return timerWrap.hide(); // Ensures valid countdown

    const update = () => {
      if (time < 0) return timerWrap.hide();
      timer.text([Math.floor(time / 3600), Math.floor((time % 3600) / 60), time % 60]
        .map(v => v.toString().padStart(2, '0')).join(':'));
      time--;
    };

    update();
    setInterval(update, 1000);
  }


  // Initialize section code
  if ($('.announcement__timer').length > 0) {
    AnnouncementTimer();
  }

  $('.ScrollToProduct').on('click', function (e) {
    e.preventDefault();
    const offsetTop = $('#product-main').offset().top - 120;
    $('html, body').animate({
      scrollTop: offsetTop
    }, 500);
  });

  $('.AddToCart').on('click', function (e) {
    e.preventDefault();
    const variantId = $(this).data('id');
    $.post((((window.Shopify||{}).routes||{}).root||'/') + 'cart/add.js', {
      items: [{ id: variantId, quantity: 1 }]
    }, function (response) {
      log.collapse(response, 'Added to Cart', 'success');
      theme.ajaxCart.update();
    }).fail(function (response) {
      log.collapse(response, 'Add to Cart Failed', 'error');
    });
  });

  $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
  $(".accordion > .accordion-item.is-active").children(".accordion-panel").slideDown();
  $(".accordion > .accordion-item").click(function () {
    $(this).siblings(".accordion-item").removeClass("is-active").children(".accordion-panel").slideUp();
    $(this).toggleClass("is-active").children(".accordion-panel").slideToggle("ease-out");
  });
});